export default __webpack_public_path__ + "static/media/historic_openapi.f176172c.yaml";